import { render, staticRenderFns } from "./CompareCatalogItem.vue?vue&type=template&id=10655648&"
import script from "./CompareCatalogItem.vue?vue&type=script&lang=js&"
export * from "./CompareCatalogItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports